export var PaymentExceptionCodesApi;
(function (PaymentExceptionCodesApi) {
    PaymentExceptionCodesApi["DAO_EXCEPTION"] = "dao_exception";
    PaymentExceptionCodesApi["DB_EXCEPTION"] = "db_exception";
    PaymentExceptionCodesApi["GAF_EXCEPTION"] = "gaf_exception";
    PaymentExceptionCodesApi["INVALID_REQUEST"] = "invalid_request";
    PaymentExceptionCodesApi["UNKNOWN_ERROR"] = "unknown_error";
    PaymentExceptionCodesApi["DEPOSIT_FEE_INVALID"] = "deposit_fee_invalid";
    PaymentExceptionCodesApi["DEPOSIT_METHOD_INVALID"] = "deposit_method_invalid";
    PaymentExceptionCodesApi["DEPOSIT_CANCEL_URL_INVALID"] = "deposit_cancel_url_invalid";
    PaymentExceptionCodesApi["DEPOSIT_SETUP_FAIL"] = "deposit_setup_fail";
    PaymentExceptionCodesApi["DEPOSIT_API_FAIL"] = "deposit_api_fail";
    PaymentExceptionCodesApi["DEPOSIT_ALREADY_BILLING_AGREEMENT"] = "deposit_already_billing_agreement";
    PaymentExceptionCodesApi["DEPOSIT_INVOICE_INVALID"] = "deposit_invoice_invalid";
    PaymentExceptionCodesApi["DEPOSIT_ALREADY_CONFIRMED"] = "deposit_already_confirmed";
    PaymentExceptionCodesApi["DEPOSIT_CONFIRM_FAIL"] = "deposit_confirm_fail";
    PaymentExceptionCodesApi["DEPOSIT_AUTHORIZE_FAIL"] = "deposit_authorize_fail";
    PaymentExceptionCodesApi["DEPOSIT_USER_ID_INVALID"] = "deposit_user_id_invalid";
    PaymentExceptionCodesApi["CHARGE_FAIL"] = "charge_fail";
    PaymentExceptionCodesApi["CHARGE_FAIL_NOT_SUPPORTED"] = "charge_fail_not_supported";
    PaymentExceptionCodesApi["CHARGE_PENDING"] = "charge_pending";
    PaymentExceptionCodesApi["CHARGE_VALIDATION_FAIL"] = "charge_validation_fail";
    PaymentExceptionCodesApi["REFUND_FAIL"] = "refund_fail";
    PaymentExceptionCodesApi["REFUND_VALIDATION_FAIL"] = "refund_validation_fail";
    PaymentExceptionCodesApi["TRANSACTION_VALIDATION_FAIL"] = "transaction_validation_fail";
    PaymentExceptionCodesApi["TRANSACTION_NOT_FOUND"] = "transaction_not_found";
    PaymentExceptionCodesApi["REFUND_CHARGE_FAIL"] = "refund_charge_fail";
    PaymentExceptionCodesApi["PAY_INVOICE_UNAUTHORIZED_REQUEST"] = "pay_invoice_unauthorized_request";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_INCOMPLETE_USER_DETAILS"] = "pay_invoice_fail_incomplete_user_details";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_ESCROW_INVOICE_CLEARED"] = "pay_invoice_fail_escrow_invoice_cleared";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_ESCROW_INVOICE_CANCELLED"] = "pay_invoice_fail_escrow_invoice_cancelled";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_UNABLE_TO_RELEASE_ESCROW_MILESTONE"] = "pay_invoice_fail_unable_to_release_escrow_milestone";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_INVOICE_IS_PAID_OR_WITHDRAWN"] = "pay_invoice_fail_invoice_is_paid_or_withdrawn";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_MISMATCH_INVOICE_AMOUNT"] = "pay_invoice_fail_mismatch_invoice_amount";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_PAYMENT_AMOUNT_GREATER_THAN_INVOICE_AMOUNT"] = "pay_invoice_fail_payment_amount_greater_than_invoice_amount";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_INSUFFICIENT_FUNDS"] = "pay_invoice_fail_insufficient_funds";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_INVALID_MILESTONE"] = "pay_invoice_fail_invalid_milestone";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_INVALID_INVOICE"] = "pay_invoice_fail_invalid_invoice";
    PaymentExceptionCodesApi["PAY_INVOICE_FAIL_SERVER_ERROR"] = "pay_invoice_fail_server_error";
    PaymentExceptionCodesApi["CART_PAYMENT_REQUIRED"] = "cart_payment_required";
    PaymentExceptionCodesApi["DEPOSIT_APPROVAL_REQUIRED"] = "deposit_approval_required";
    PaymentExceptionCodesApi["TAX_STATEMENT_NOT_FOUND"] = "tax_statement_not_found";
    PaymentExceptionCodesApi["PAYOUT_LIMIT_EXEMPTION_DUPLICATE"] = "payout_limit_exemption_duplicate";
    PaymentExceptionCodesApi["PAYOUT_LIMIT_EXEMPTION_NOT_FOUND"] = "payout_limit_exemption_not_found";
})(PaymentExceptionCodesApi || (PaymentExceptionCodesApi = {}));
export var DepositMethodApi;
(function (DepositMethodApi) {
    DepositMethodApi["PAYPAL"] = "paypal";
    DepositMethodApi["FLN_BILLING"] = "fln_billing";
    DepositMethodApi["SKRILL"] = "skrill";
    DepositMethodApi["WEB_MONEY"] = "web_money";
    DepositMethodApi["WIRE"] = "wire";
    DepositMethodApi["PAYPAL_REFERENCE"] = "paypal_reference";
    DepositMethodApi["BOLETO"] = "boleto";
    DepositMethodApi["ALIPAY"] = "alipay";
    DepositMethodApi["UNION_PAY"] = "union_pay";
    DepositMethodApi["IDEAL"] = "ideal";
    DepositMethodApi["SOFORT"] = "sofort";
    DepositMethodApi["GIROPAY"] = "giropay";
    DepositMethodApi["INTERAC"] = "interac";
    DepositMethodApi["BANCONTACT"] = "bancontact";
    DepositMethodApi["DOTPAY"] = "dotpay";
    DepositMethodApi["PAYTM"] = "paytm";
    DepositMethodApi["PAYTM_SUBSCRIPTION"] = "paytm_subscription";
    DepositMethodApi["WECHATPAY"] = "wechatpay";
    DepositMethodApi["GOOGLEPAY"] = "googlepay";
    DepositMethodApi["APPLEPAY"] = "applepay";
    DepositMethodApi["LOC"] = "loc";
    DepositMethodApi["DEV_CREDITS"] = "dev_credits";
    DepositMethodApi["EPHEMERAL_CREDITS"] = "ephemeral_credits";
    DepositMethodApi["TEAM_BILLING"] = "team_billing";
    DepositMethodApi["ENTERPRISE_BILLING"] = "enterprise_billing";
})(DepositMethodApi || (DepositMethodApi = {}));
export const VIRTUAL_PAYMENT_TYPEApi = [
    DepositMethodApi.DEV_CREDITS,
    DepositMethodApi.EPHEMERAL_CREDITS,
    DepositMethodApi.TEAM_BILLING,
    DepositMethodApi.ENTERPRISE_BILLING,
];
export var ChargeTypeApi;
(function (ChargeTypeApi) {
    ChargeTypeApi["MEMBERSHIP_FEE"] = "membership_fee";
})(ChargeTypeApi || (ChargeTypeApi = {}));
export var FxTypeApi;
(function (FxTypeApi) {
    FxTypeApi["DEPOSIT"] = "deposit";
    FxTypeApi["OTHER"] = "other";
})(FxTypeApi || (FxTypeApi = {}));
export var CreditCardGatewayApi;
(function (CreditCardGatewayApi) {
    CreditCardGatewayApi["WORLDPAY"] = "worldpay";
    CreditCardGatewayApi["GC"] = "gc";
    CreditCardGatewayApi["ADYEN"] = "adyen";
    CreditCardGatewayApi["NAB"] = "nab";
    CreditCardGatewayApi["EBANX"] = "ebanx";
    CreditCardGatewayApi["SVB"] = "svb";
})(CreditCardGatewayApi || (CreditCardGatewayApi = {}));
export var CreditCardTypeApi;
(function (CreditCardTypeApi) {
    CreditCardTypeApi["MASTERCARD"] = "mastercard";
    CreditCardTypeApi["VISA"] = "visa";
    CreditCardTypeApi["AMEX"] = "amex";
    CreditCardTypeApi["VISA_ELECTRON"] = "visa_electron";
    CreditCardTypeApi["JCB"] = "jcb";
    CreditCardTypeApi["DELTA"] = "delta";
    CreditCardTypeApi["AURA"] = "aura";
    CreditCardTypeApi["ELO"] = "elo";
    CreditCardTypeApi["HIPERCARD"] = "hipercard";
    CreditCardTypeApi["CARNET"] = "carnet";
    CreditCardTypeApi["DINERS"] = "diners";
    CreditCardTypeApi["DISCOVER"] = "discover";
    CreditCardTypeApi["MAESTRO"] = "maestro";
})(CreditCardTypeApi || (CreditCardTypeApi = {}));
export var HourlyContractActionApi;
(function (HourlyContractActionApi) {
    HourlyContractActionApi["UPDATE"] = "update";
    HourlyContractActionApi["ENABLE_TIME_TRACKING"] = "enable_time_tracking";
    HourlyContractActionApi["STOP_TIME_TRACKING"] = "stop_time_tracking";
})(HourlyContractActionApi || (HourlyContractActionApi = {}));
export var HourlyContractBillingCycleApi;
(function (HourlyContractBillingCycleApi) {
    HourlyContractBillingCycleApi["WEEKLY"] = "weekly";
    HourlyContractBillingCycleApi["MONTHLY"] = "monthly";
})(HourlyContractBillingCycleApi || (HourlyContractBillingCycleApi = {}));
export var ProjectInvoiceMilestoneLinkedStatusesApi;
(function (ProjectInvoiceMilestoneLinkedStatusesApi) {
    ProjectInvoiceMilestoneLinkedStatusesApi["LINKED"] = "linked";
    ProjectInvoiceMilestoneLinkedStatusesApi["UNLINKED"] = "unlinked";
})(ProjectInvoiceMilestoneLinkedStatusesApi || (ProjectInvoiceMilestoneLinkedStatusesApi = {}));
export var ConsolidatedInvoiceItemTypeApi;
(function (ConsolidatedInvoiceItemTypeApi) {
    ConsolidatedInvoiceItemTypeApi["RECEIPT"] = "receipt";
    ConsolidatedInvoiceItemTypeApi["INVOICE"] = "invoice";
    ConsolidatedInvoiceItemTypeApi["REFUND"] = "refund";
    ConsolidatedInvoiceItemTypeApi["REVERSAL"] = "reversal";
})(ConsolidatedInvoiceItemTypeApi || (ConsolidatedInvoiceItemTypeApi = {}));
export var ConsolidatedInvoiceItemSubTypeApi;
(function (ConsolidatedInvoiceItemSubTypeApi) {
    ConsolidatedInvoiceItemSubTypeApi["MILESTONE"] = "milestone";
    ConsolidatedInvoiceItemSubTypeApi["PROJECT_FEE"] = "project_fee";
    ConsolidatedInvoiceItemSubTypeApi["TAX"] = "tax";
    ConsolidatedInvoiceItemSubTypeApi["DEPOSIT"] = "deposit";
    ConsolidatedInvoiceItemSubTypeApi["DEPOSIT_FEE"] = "deposit_fee";
    ConsolidatedInvoiceItemSubTypeApi["MILESTONE_BIDDER"] = "milestone_bidder";
})(ConsolidatedInvoiceItemSubTypeApi || (ConsolidatedInvoiceItemSubTypeApi = {}));
export var ConsolidatedInvoiceContextTypeApi;
(function (ConsolidatedInvoiceContextTypeApi) {
    ConsolidatedInvoiceContextTypeApi["PROJECT"] = "project";
})(ConsolidatedInvoiceContextTypeApi || (ConsolidatedInvoiceContextTypeApi = {}));
export var ThreedsCapabilityApi;
(function (ThreedsCapabilityApi) {
    ThreedsCapabilityApi["NONE"] = "none";
    ThreedsCapabilityApi["VER1"] = "ver1";
    ThreedsCapabilityApi["VER2"] = "ver2";
})(ThreedsCapabilityApi || (ThreedsCapabilityApi = {}));
export var InvoiceStatusApi;
(function (InvoiceStatusApi) {
    InvoiceStatusApi["DRAFT"] = "draft";
    InvoiceStatusApi["UNPAID"] = "unpaid";
    InvoiceStatusApi["PAID"] = "paid";
    InvoiceStatusApi["WITHDRAWN"] = "withdrawn";
    InvoiceStatusApi["DISPUTED"] = "disputed";
    InvoiceStatusApi["PARTIALLY_PAID"] = "partially_paid";
})(InvoiceStatusApi || (InvoiceStatusApi = {}));
export var InvoiceItemTypeApi;
(function (InvoiceItemTypeApi) {
    InvoiceItemTypeApi["OTHER"] = "other";
    InvoiceItemTypeApi["HOURS"] = "hours";
    InvoiceItemTypeApi["RESULT"] = "result";
})(InvoiceItemTypeApi || (InvoiceItemTypeApi = {}));
export var ItemStatusApi;
(function (ItemStatusApi) {
    ItemStatusApi["NOT_DONE"] = "not_done";
    ItemStatusApi["ERROR"] = "error";
    ItemStatusApi["DONE"] = "done";
    ItemStatusApi["CANCELLED"] = "cancelled";
})(ItemStatusApi || (ItemStatusApi = {}));
export var ContextTypeApi;
(function (ContextTypeApi) {
    ContextTypeApi["EXAM"] = "exam";
    ContextTypeApi["MILESTONE"] = "milestone";
    ContextTypeApi["PROJECT_UPGRADE"] = "project_upgrade";
    ContextTypeApi["PROJECT_FEE"] = "project_fee";
    ContextTypeApi["CONTEST_UPGRADE"] = "contest_upgrade";
    ContextTypeApi["BID_UPGRADE"] = "bid_upgrade";
    ContextTypeApi["TIP"] = "tip";
    ContextTypeApi["CONTEST_ENTRY_BUY"] = "contest_entry_buy";
    ContextTypeApi["CONTEST_PRIZE_UPGRADE"] = "contest_prize_upgrade";
    ContextTypeApi["CONTEST_EXTEND"] = "contest_extend";
    ContextTypeApi["CONTEST_PRIZE_BUNDLE"] = "contest_prize_bundle";
    ContextTypeApi["FREELANCER_VERIFIED"] = "freelancer_verified";
    ContextTypeApi["HOURLY_INITIAL_PAYMENT"] = "hourly_initial_payment";
    ContextTypeApi["DISPUTE_ARBITRATION_FEE"] = "dispute_arbitration_fee";
    ContextTypeApi["LEVY"] = "levy";
    ContextTypeApi["QUOTATION_FUND_PROACTIVE"] = "quotation_fund_proactive";
    ContextTypeApi["QUOTATION_FUND_REQUESTED"] = "quotation_fund_requested";
    ContextTypeApi["MEMBERSHIP_SUBSCRIPTION"] = "membership_subscription";
    ContextTypeApi["MEMBERSHIP_RENEWAL"] = "membership_renewal";
    ContextTypeApi["BID_PACK"] = "bid_pack";
    ContextTypeApi["SUBSCRIPTION_ITEM"] = "subscription_item";
    ContextTypeApi["SUBSCRIPTION_ITEM_RECURRING"] = "subscription_item_recurring";
    ContextTypeApi["CONTEST_ENTRY_UPGRADE"] = "contest_entry_upgrade";
})(ContextTypeApi || (ContextTypeApi = {}));
export var DestinationApi;
(function (DestinationApi) {
    DestinationApi["DASHBOARD"] = "dashboard";
    DestinationApi["PROJECT_VIEW_PAGE"] = "project_view_page";
    DestinationApi["CONTEST_VIEW_PAGE"] = "contest_view_page";
    DestinationApi["CONTEST_ENTRY_HANDOVER_PAGE"] = "contest_entry_handover_page";
    DestinationApi["FREELANCER_VERIFIED_LANDING_PAGE"] = "freelancer_verified_landing_page";
    DestinationApi["DISPUTE_PAGE"] = "dispute_page";
    DestinationApi["NONE"] = "none";
})(DestinationApi || (DestinationApi = {}));
export var CartStatusApi;
(function (CartStatusApi) {
    CartStatusApi["UNPAID"] = "unpaid";
    CartStatusApi["DEPOSITED"] = "deposited";
    CartStatusApi["CHARGED"] = "charged";
    CartStatusApi["PARTIALLY_DEPOSITED"] = "partially_deposited";
    CartStatusApi["ERROR"] = "error";
})(CartStatusApi || (CartStatusApi = {}));
export var CartApprovalStatusApi;
(function (CartApprovalStatusApi) {
    CartApprovalStatusApi["PENDING"] = "pending";
    CartApprovalStatusApi["APPROVED"] = "approved";
    CartApprovalStatusApi["REJECTED"] = "rejected";
    CartApprovalStatusApi["CANCELLED"] = "cancelled";
})(CartApprovalStatusApi || (CartApprovalStatusApi = {}));
export var ProjectFeeTypeApi;
(function (ProjectFeeTypeApi) {
    ProjectFeeTypeApi["MILESTONE"] = "milestone";
    ProjectFeeTypeApi["HOURLY_INITIAL_PAYMENT"] = "hourly_initial_payment";
    ProjectFeeTypeApi["FIXED_PRICE_PROJECT"] = "fixed_price_project";
    ProjectFeeTypeApi["QUOTATION_INITIAL_FIXED"] = "quotation_initial_fixed";
    ProjectFeeTypeApi["SUBSCRIPTION_ITEM"] = "subscription_item";
})(ProjectFeeTypeApi || (ProjectFeeTypeApi = {}));
export var TransactionHistoryCategoryApi;
(function (TransactionHistoryCategoryApi) {
    TransactionHistoryCategoryApi["CREATE"] = "create";
    TransactionHistoryCategoryApi["FEE"] = "fee";
})(TransactionHistoryCategoryApi || (TransactionHistoryCategoryApi = {}));
export var TransactionHistoryLabelApi;
(function (TransactionHistoryLabelApi) {
    TransactionHistoryLabelApi["PROJECT_NAME"] = "project_name";
    TransactionHistoryLabelApi["USER_NAME"] = "user_name";
    TransactionHistoryLabelApi["INVOICE_NAME"] = "invoice_name";
    TransactionHistoryLabelApi["TRANSACTION_ID"] = "transaction_id";
    TransactionHistoryLabelApi["CONTACT_SUPPORT"] = "contact_support";
    TransactionHistoryLabelApi["TRANSACTION_DATE"] = "transaction_date";
    TransactionHistoryLabelApi["PLACEHOLDER"] = "placeholder";
    TransactionHistoryLabelApi["DESCRIPTION"] = "description";
    TransactionHistoryLabelApi["STATUS"] = "status";
    TransactionHistoryLabelApi["EMPLOYER"] = "employer";
})(TransactionHistoryLabelApi || (TransactionHistoryLabelApi = {}));
export var TransactionHistoryContextTypeApi;
(function (TransactionHistoryContextTypeApi) {
    TransactionHistoryContextTypeApi["MILESTONE"] = "milestone";
})(TransactionHistoryContextTypeApi || (TransactionHistoryContextTypeApi = {}));
export var PayoutMethodTypeEnumApi;
(function (PayoutMethodTypeEnumApi) {
    PayoutMethodTypeEnumApi["WIRE"] = "wire";
    PayoutMethodTypeEnumApi["EXPRESS"] = "express";
    PayoutMethodTypeEnumApi["PAYPAL"] = "paypal";
    PayoutMethodTypeEnumApi["SKRILL"] = "skrill";
    PayoutMethodTypeEnumApi["PAYONEER"] = "payoneer";
})(PayoutMethodTypeEnumApi || (PayoutMethodTypeEnumApi = {}));
export var PayoutProviderTypeEnumApi;
(function (PayoutProviderTypeEnumApi) {
    PayoutProviderTypeEnumApi["BANK"] = "bank";
    PayoutProviderTypeEnumApi["HYPERWALLET"] = "hyperwallet";
    PayoutProviderTypeEnumApi["WORLDPAY"] = "worldpay";
})(PayoutProviderTypeEnumApi || (PayoutProviderTypeEnumApi = {}));
export var PayoutNotificationTypeEnumApi;
(function (PayoutNotificationTypeEnumApi) {
    PayoutNotificationTypeEnumApi["INFO"] = "info";
    PayoutNotificationTypeEnumApi["WARNING"] = "warning";
})(PayoutNotificationTypeEnumApi || (PayoutNotificationTypeEnumApi = {}));
export var PayoutAccountFormComponentTypeEnumApi;
(function (PayoutAccountFormComponentTypeEnumApi) {
    PayoutAccountFormComponentTypeEnumApi["NOTIFICATION"] = "notification";
    PayoutAccountFormComponentTypeEnumApi["INPUT_FIELD"] = "input_field";
})(PayoutAccountFormComponentTypeEnumApi || (PayoutAccountFormComponentTypeEnumApi = {}));
export var PayoutAccountFormInputFieldTypeEnumApi;
(function (PayoutAccountFormInputFieldTypeEnumApi) {
    PayoutAccountFormInputFieldTypeEnumApi["TEXT"] = "text";
    PayoutAccountFormInputFieldTypeEnumApi["SELECT"] = "select";
})(PayoutAccountFormInputFieldTypeEnumApi || (PayoutAccountFormInputFieldTypeEnumApi = {}));
export var TaxStatementTypeEnumApi;
(function (TaxStatementTypeEnumApi) {
    TaxStatementTypeEnumApi["IN_TDS"] = "in_tds";
    TaxStatementTypeEnumApi["US_1099K"] = "us_1099k";
})(TaxStatementTypeEnumApi || (TaxStatementTypeEnumApi = {}));
export var TaxStatementStateEnumApi;
(function (TaxStatementStateEnumApi) {
    TaxStatementStateEnumApi["DISABLED"] = "disabled";
    TaxStatementStateEnumApi["ACTIVE"] = "active";
})(TaxStatementStateEnumApi || (TaxStatementStateEnumApi = {}));
export var TaxFileTypeEnumApi;
(function (TaxFileTypeEnumApi) {
    TaxFileTypeEnumApi["INDIVIDUAL"] = "individual";
    TaxFileTypeEnumApi["ARCHIVED"] = "archived";
})(TaxFileTypeEnumApi || (TaxFileTypeEnumApi = {}));
export var PayoutAccountStatusEnumApi;
(function (PayoutAccountStatusEnumApi) {
    PayoutAccountStatusEnumApi["PENDING"] = "pending";
    PayoutAccountStatusEnumApi["APPROVED"] = "approved";
    PayoutAccountStatusEnumApi["DISABLED"] = "disabled";
    PayoutAccountStatusEnumApi["BLOCKED"] = "blocked";
})(PayoutAccountStatusEnumApi || (PayoutAccountStatusEnumApi = {}));
